import axios from 'axios'
import qs from 'qs'
import { Notification } from 'element-ui'

// 创建一个axios的实例,传的参数可以点击axios进去查看
// create(config?: AxiosRequestConfig): AxiosInstance;
// create 方法返回一个AxiosInstance
// 我们去到实例之后,可以搭建前台的拦截器
const service = axios.create({
  // baseURL: '/api',
  timeout: 30000
})

const err = error => {
  if (error.response) {
    if (error.response.status === 404) {
      // 资源丢失
      Notification({
        title: '访问错误',
        message: '资源丢失,请联系管理员'
      })
    } else if (error.response.status === 401) {
      // 登录失效,退出登录
      window.location.href = '../login/login.html?to=' + escape(window.location.href)
    } else {
      // 提示错误
      Notification({
        message: error.response.status === 500 ? '错误' : '提示',
        description: error.response.data ? error.response.data : '操作失败,请重试!'
      })
    }
  }
  throw error
}

// request interceptor
service.interceptors.request.use(config => {
  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  // 如果token在data中带，需要在这边修改config.data
  if (config.data && typeof config.data !== 'string' && config.headers['Content-Type'] !== 'multipart/form-data') {
    config.data = qs.stringify(config.data)
  }
  // 增加token
  // const token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  //   config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  // }
  config.headers['X-Requested-with'] = 'XMLHttpRequest'
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.axios = service
    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get() {
          return service
        }
      },
      $http: {
        get: function get() {
          return service
        }
      }
    })
  }
}

export { installer as VueAxios, service }
